"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.partition = partition;
var _remeda = require("remeda");
/**
 * partition the elements of an array to two or more arrays as specified in a callback function.
 * @param array The array to partition.
 * @param fn the callback function.
 * @signature
 *    R.partition(array, fn)
 *    R.partition.indexed(array, fn)
 * @example
 *    R.partition([1, 2, 3], x => x % 2 === 1) // => [[1, 3], [2]]
 *    R.partition.indexed([1, 2, 3], (x, i, array) => x % 2 === 1) // => [[1, 3], [2]]
 * @data_first
 * @indexed
 * @category Array
 */
;

/**
 * Partition the elements of an array to two or more arrays.
 * @param fn the callback function.
 * @signature
 *    R.partition(fn)(array)
 *    R.partition.indexed(fn)(array)
 * @example
 *    R.pipe([1, 2, 3], R.partition(x => x % 2 === 1)) // => [[1, 3], [2]]
 *    R.pipe([1, 2, 3], R.partition.indexed((x, i) => x % 2 === 1)) // => [[1, 3], [2]]
 * @data_last
 * @indexed
 * @category Array
 */

function partition() {
  return (0, _remeda.purry)(_partition(false), arguments);
}
const _partition = indexed => (array, fn) => {
  let partitions = [[], []];
  for (let [index, val] of array.entries()) {
    let part = indexed ? fn(val, index, array) : fn(val);
    if (typeof part === "number") {
      while (part >= partitions.length) {
        partitions.push([]);
      }
      partitions[part].push(val);
    } else {
      partitions[part ? 0 : 1].push(val);
    }
  }
  return partitions;
};
(function (_partition2) {
  /**
   * @data_last
   */

  function indexed() {
    return (0, _remeda.purry)(_partition(true), arguments);
  }
  _partition2.indexed = indexed;
})(partition || (exports.partition = partition = {}));
//# sourceMappingURL=partition.js.map